import { ArrowUpRight, MapPin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const CONTACTS = [
  { label: "For Advertisers", email: "sales@adstellarmedia.com" },
  { label: "For Publishers", email: "supply@adstellarmedia.com" },
  { label: "Other Enquiries", email: "biz@adstellarmedia.com" },
];

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="relative py-32 md:py-48 border-t border-white/10 overflow-hidden"
  >
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(ellipse 50% 60% at 50% 100%, rgba(139,92,246,0.12), transparent 70%)" }}
      aria-hidden="true"
    />
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
      <Reveal>
        <Overline>Let's Collaborate</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-8 font-display text-[clamp(2.6rem,7vw,6.5rem)] leading-[1.02] tracking-tight max-w-5xl" data-testid="contact-heading">
          Empower Your Brand<br />With <span className="italic text-[#8B5CF6]">AdStellar</span> Today.
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-8 max-w-xl text-base md:text-lg text-[#A0A0AB] font-light leading-relaxed">
          Let's create campaigns that don't just perform — they inspire.
          Together, we can make your brand unforgettable.
        </p>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {CONTACTS.map((c, i) => (
          <Reveal key={c.email} delay={0.1 + i * 0.08} y={24}>
            <a
              href={`mailto:${c.email}`}
              data-testid={`contact-card-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group block h-full bg-[#09090A] p-8 md:p-10 transition-colors duration-500 hover:bg-[#121214]"
            >
              <div className="flex items-start justify-between">
                <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-[#52525B]">{c.label}</p>
                <ArrowUpRight className="w-4 h-4 text-[#52525B] transition-all duration-300 group-hover:text-[#8B5CF6] group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <p className="mt-6 text-lg md:text-xl text-[#F8F8F8] group-hover:text-[#8B5CF6] transition-colors duration-300 break-all">
                {c.email}
              </p>
            </a>
          </Reveal>
        ))}
      </div>

      <div className="mt-16 grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
        <Reveal y={24}>
          <div className="h-full bg-[#09090A] p-8 md:p-12" data-testid="contact-address-block">
            <div className="flex items-center gap-3">
              <MapPin className="w-5 h-5 text-[#8B5CF6]" strokeWidth={1.5} />
              <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-[#52525B]">Visit Us</p>
            </div>
            <address className="mt-6 not-italic font-display text-2xl md:text-3xl leading-snug tracking-tight">
              Unit No- 716, 7th Floor<br />
              ILD Trade Center, D1 Block<br />
              Malibu Town, Sector 47<br />
              Gurugram, Haryana 122018
            </address>
            <a
              href="https://maps.app.goo.gl/VK1LtkPioeGNT7u46"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-directions-link"
              className="group mt-8 inline-flex items-center gap-2 font-accent text-xs tracking-[0.25em] uppercase text-[#A0A0AB] hover:text-[#8B5CF6] transition-colors duration-300"
            >
              Get Directions
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </div>
        </Reveal>
        <Reveal y={24} delay={0.1}>
          <div className="h-full min-h-[360px] bg-[#09090A]">
            <iframe
              title="AdStellar Media office — ILD Trade Center, Sector 47, Gurugram"
              data-testid="contact-map-embed"
              src="https://www.google.com/maps?q=ILD+Trade+Center,+Sector+47,+Gurugram,+Haryana+122018&output=embed"
              className="w-full h-full min-h-[360px] border-0 grayscale invert-[0.92] contrast-[0.85]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-8">
          <a
            href="mailto:biz@adstellarmedia.com?subject=Campaign%20Enquiry%20—%20AdStellar%20Media"
            data-testid="contact-mailto-button"
            className="group inline-flex items-center gap-4 bg-[#8B5CF6] text-white px-10 py-6 font-accent text-sm tracking-[0.25em] uppercase hover:bg-[#A78BFA] transition-colors duration-300"
          >
            Talk to Our Experts
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
          <a
            href="mailto:biz@adstellarmedia.com"
            data-testid="contact-email-link"
            className="font-accent text-sm tracking-[0.15em] text-[#A0A0AB] hover:text-[#8B5CF6] transition-colors duration-300 underline underline-offset-8 decoration-white/20 hover:decoration-[#8B5CF6]"
          >
            biz@adstellarmedia.com
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
